// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Header-module--wrapper--1TXU-","currentDate":"Header-module--currentDate--6w--W","title":"Header-module--title--1ZZbS"};